export const getFirstLetters = (word) => {
    if (word) {
        return word.split(' ')
            .map(word => word.charAt(0))
            .join('');
    }
    return '';
}
